// 揽收运营数据看板（collectionOperationDashboard）
// 独立语言包：页面文案较多，避免继续膨胀 newCollectionCenter.js
const collectionOperationDashboard = {
  pageTitle: {
    zh: '揽收运营数据看板',
    en: 'Collection Operations Dashboard',
    pu: 'Painel de Operação de Coleta'
  },
  pageSubtitle: {
    zh: 'Coleta · 巴西全境客户订单、装车完成、Miss Scan 与多UF城市表现',
    en: 'Coleta · Client orders across Brazil, loading completion, Miss Scan and multi-UF city performance',
    pu: 'Coleta · Pedidos de clientes em todo o Brasil, conclusão de carregamento, Miss Scan e desempenho por cidade e UF'
  },
  dataUpdatedAt: {
    zh: '数据更新时间',
    en: 'Data updated at',
    pu: 'Dados atualizados em'
  },
  coverageBadge: {
    zh: '巴西全境 · 27 UF',
    en: 'Brazil · 27 UF',
    pu: 'Brasil · 27 UF'
  },
  filterTitle: {
    zh: '全局筛选',
    en: 'Global filters',
    pu: 'Filtros globais'
  },
  filterDesc: {
    zh: '所有指标、图表与明细将同步刷新',
    en: 'All KPIs, charts and details refresh together',
    pu: 'Todos os KPIs, gráficos e detalhes são atualizados juntos'
  },
  timeLabel: {
    zh: '时间',
    en: 'Date',
    pu: 'Data'
  },
  allClients: {
    zh: '全部客户',
    en: 'All clients',
    pu: 'Todos os clientes'
  },
  allServices: {
    zh: '全部服务',
    en: 'All services',
    pu: 'Todos os serviços'
  },
  allUf: {
    zh: '全部 UF（巴西全境）',
    en: 'All UF (Brazil)',
    pu: 'Todos os UF (Brasil)'
  },
  cityPlaceholder: {
    zh: '输入搜索城市，不选 UF 全局搜',
    en: 'Type to search cities; without UF it searches nationwide',
    pu: 'Digite para buscar cidades; sem UF busca em todo o país'
  },
  allHub: {
    zh: '全部 HUB',
    en: 'All HUBs',
    pu: 'Todos os HUBs'
  },
  mapTitle: {
    zh: '巴西各州客户订单分布',
    en: 'Client order distribution by UF',
    pu: 'Distribuição de pedidos de clientes por UF'
  },
  mapSubtitle: {
    zh: 'Mapa da coleta por UF · 州面颜色表示订单规模，州内圆环表示客户构成',
    en: 'Mapa da coleta por UF · state color shows order volume, inner rings show client mix',
    pu: 'Mapa da coleta por UF · a cor do estado indica o volume de pedidos e os anéis indicam o mix de clientes'
  },
  mapLive: {
    zh: '全国揽收热力',
    en: 'Nationwide collection heat',
    pu: 'Mapa de calor da coleta nacional'
  },
  mapClickTip: {
    zh: '点击州查看该州概览',
    en: 'Click a state to see its overview',
    pu: 'Clique em um estado para ver o resumo'
  },
  mapAriaLabel: {
    zh: '巴西各州客户揽收分布地图',
    en: 'Collection distribution map by Brazilian state',
    pu: 'Mapa de distribuição de coleta por estado do Brasil'
  },
  mapNoData: {
    zh: '暂无揽收数据',
    en: 'No collection data',
    pu: 'Sem dados de coleta'
  },
  mapNote: {
    zh: '点击州查看该州概览；悬浮查看客户明细',
    en: 'Click a state for its overview; hover for client details',
    pu: 'Clique no estado para o resumo; passe o mouse para detalhes por cliente'
  },
  mapFoot: {
    zh: '地图统计口径与顶部筛选条件同步；悬浮可查看各客户揽收明细。',
    en: 'The map follows the filters above; hover to see client details.',
    pu: 'O mapa segue os filtros acima; passe o mouse para ver os detalhes por cliente.'
  },
  coverage: {
    zh: '覆盖范围',
    en: 'Coverage',
    pu: 'Cobertura'
  },
  topClient: {
    zh: '第一大客户',
    en: 'Top client',
    pu: 'Maior cliente'
  },
  ufRanking: {
    zh: 'UF 排名',
    en: 'UF ranking',
    pu: 'Ranking de UF'
  },
  nationalOverview: {
    zh: '全国概览',
    en: 'National overview',
    pu: 'Visão nacional'
  },
  stateOverview: {
    zh: '{uf} 州概览',
    en: '{uf} overview',
    pu: 'Visão do estado {uf}'
  },
  platformCollect: {
    zh: '{platform}揽收量',
    en: '{platform} collected volume',
    pu: 'Volume de coleta {platform}'
  },
  ufCount: {
    zh: '{count} UF',
    en: '{count} UF',
    pu: '{count} UF'
  },
  unknownState: {
    zh: '未知',
    en: 'Unknown',
    pu: 'Desconhecido'
  },
  unknownStateHint: {
    zh: '其中 {count} 件无发件州，未上图',
    en: '{count} pcs have no origin state (not shown on map)',
    pu: '{count} pcts sem estado de origem (não exibidos no mapa)'
  },
  keywordFiltered: {
    zh: '按「{keyword}」筛选，共 {count} 条（导出同条件）',
    en: 'Filtered by "{keyword}": {count} rows (export uses the same filter)',
    pu: 'Filtrado por "{keyword}": {count} linhas (exportação com o mesmo filtro)'
  },
  piece: {
    zh: '件',
    en: 'pcs',
    pu: 'pcts'
  },
  unknownClient: {
    zh: '未知客户',
    en: 'Unknown client',
    pu: 'Cliente desconhecido'
  },
  sectionTitle: {
    zh: '揽收 Coleta',
    en: 'Collection Coleta',
    pu: 'Coleta'
  },
  sectionDesc: {
    zh: '当天揽收、第一次装车、Miss Scan 和城市履约表现',
    en: 'Same-day collection, first loading, Miss Scan and city performance',
    pu: 'Coleta do dia, primeiro carregamento, Miss Scan e desempenho por cidade'
  },
  exportCityDetail: {
    zh: '导出城市明细',
    en: 'Export city details',
    pu: 'Exportar detalhes por cidade'
  },
  dataContract: {
    zh: '业务口径',
    en: 'Business scope',
    pu: 'Escopo de negócio'
  },
  collectScan: {
    zh: '揽收订单/扫描',
    en: 'Collected orders/scans',
    pu: 'Pedidos/varreduras coletados'
  },
  firstLoading: {
    zh: '第一次装车',
    en: 'First loading',
    pu: 'Primeiro carregamento'
  },
  closedLoop: {
    zh: '闭环轨迹关联',
    en: 'Closed-loop tracking link',
    pu: 'Vínculo de rastreio fechado'
  },
  nationwideDrill: {
    zh: '全国汇总，可下钻至城市',
    en: 'Nationwide total, drillable to city',
    pu: 'Total nacional, detalhável por cidade'
  },
  kpiCollectTotal: {
    zh: '揽收总量',
    en: 'Total collected',
    pu: 'Total coletado'
  },
  kpiCollectTotalDesc: {
    zh: '揽收扫描包裹量',
    en: 'Packages with collection scan',
    pu: 'Pacotes com varredura de coleta'
  },
  kpiLoaded: {
    zh: '当天完成装车',
    en: 'Loaded today',
    pu: 'Carregado hoje'
  },
  kpiLoadedDesc: {
    zh: '当天完成第一次装车',
    en: 'First loading completed today',
    pu: 'Primeiro carregamento concluído hoje'
  },
  kpiUnloaded: {
    zh: '当天未完成装车',
    en: 'Not loaded today',
    pu: 'Não carregado hoje'
  },
  kpiUnloadedDesc: {
    zh: '截至统计时点未完成第一次装车',
    en: 'First loading not completed as of the snapshot time',
    pu: 'Primeiro carregamento não concluído até o momento da apuração'
  },
  kpiCollectRateDesc: {
    zh: '当天装车量 ÷ 揽收总量',
    en: 'Loaded today ÷ total collected',
    pu: 'Carregado hoje ÷ total coletado'
  },
  kpiMissScan: {
    zh: 'Miss Scan',
    en: 'Miss Scan',
    pu: 'Miss Scan'
  },
  kpiMissScanDesc: {
    zh: '已闭环但未关联揽收点',
    en: 'Closed but not linked to a collection point',
    pu: 'Fechado mas sem vínculo com ponto de coleta'
  },
  kpiMissScanRate: {
    zh: 'Miss Scan率',
    en: 'Miss Scan rate',
    pu: 'Taxa de Miss Scan'
  },
  kpiMissScanRateDesc: {
    zh: 'Miss Scan ÷ 揽收总量',
    en: 'Miss Scan ÷ total collected',
    pu: 'Miss Scan ÷ total coletado'
  },
  exportList: {
    zh: '导出清单',
    en: 'Export list',
    pu: 'Exportar lista'
  },
  trendTitle: {
    zh: '揽收趋势',
    en: 'Collection trend',
    pu: 'Tendência de coleta'
  },
  trendDesc: {
    zh: '近7天揽收量与揽收率',
    en: 'Collection volume and rate in the last 7 days',
    pu: 'Volume e taxa de coleta nos últimos 7 dias'
  },
  customerTitle: {
    zh: '按客户统计',
    en: 'By client',
    pu: 'Por cliente'
  },
  customerDesc: {
    zh: '所选UF客户揽收量',
    en: 'Client collection volume for the selected UF',
    pu: 'Volume de coleta por cliente no UF selecionado'
  },
  serviceTitle: {
    zh: '按服务类型',
    en: 'By service type',
    pu: 'Por tipo de serviço'
  },
  collectVolume: {
    zh: '揽收量',
    en: 'Collected volume',
    pu: 'Volume coletado'
  },
  collectTotal: {
    zh: '揽收总量',
    en: 'Total collected',
    pu: 'Total coletado'
  },
  ufTitle: {
    zh: '按UF统计揽收表现',
    en: 'Collection performance by UF',
    pu: 'Desempenho de coleta por UF'
  },
  ufDesc: {
    zh: '巴西全境按揽收量降序；展示Top 10及其他UF汇总',
    en: 'Nationwide, sorted by collection volume; top 10 plus other UFs',
    pu: 'Todo o Brasil por volume de coleta; top 10 e demais UF'
  },
  cityDetailTitle: {
    zh: '城市明细（多 UF）',
    en: 'City details (multi-UF)',
    pu: 'Detalhes por cidade (multi-UF)'
  },
  searchPlaceholder: {
    zh: '搜索客户 / UF / 城市',
    en: 'Search client / UF / city',
    pu: 'Buscar cliente / UF / cidade'
  },
  exportCsv: {
    zh: 'CSV 导出',
    en: 'CSV export',
    pu: 'Exportar CSV'
  },
  loadedTotal: {
    zh: '当天装车量',
    en: 'Loaded today',
    pu: 'Carregado hoje'
  },
  unloadedTotal: {
    zh: '未装车量',
    en: 'Not loaded',
    pu: 'Não carregado'
  },
  pageMatch: {
    zh: '当前页匹配 {count} 条',
    en: '{count} matches on this page',
    pu: '{count} correspondências nesta página'
  }
};

export { collectionOperationDashboard };
